module.exports = __webpack_public_path__ + "static/media/bomb.70f26d47.png";